import { render, staticRenderFns } from "./MessageBirdWizard.vue?vue&type=template&id=246904a2&"
import script from "./MessageBirdWizard.vue?vue&type=script&lang=js&"
export * from "./MessageBirdWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports